import { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { QuestionListParams } from '../api/questions-api';
import type { SaleListParams } from '../api/sales-api';

import { QUESTION_TABS, SALE_TABS, type QuestionTab, type SaleTab } from './sale-rules';

/** URL search params of the sales list: a status tab (live when absent) and the cursor. */
export const saleListSearchSchema = indexSearchSchema([]).extend({
  status: z.enum(SALE_TABS).optional().catch(undefined),
});
export type SaleListSearch = z.infer<typeof saleListSearchSchema>;

export function saleTab(search: Pick<SaleListSearch, 'status'>): SaleTab {
  return search.status ?? 'live';
}

export function saleListParams(search: SaleListSearch): SaleListParams {
  return { ...listParams(search), status: saleTab(search) };
}

/** URL search params of the question queue: pending when absent. */
export const questionListSearchSchema = indexSearchSchema([]).extend({
  status: z.enum(QUESTION_TABS).optional().catch(undefined),
});
export type QuestionListSearch = z.infer<typeof questionListSearchSchema>;

export function questionTab(search: Pick<QuestionListSearch, 'status'>): QuestionTab {
  return search.status ?? 'pending';
}

export function questionListParams(search: QuestionListSearch): QuestionListParams {
  return { ...listParams(search), status: questionTab(search) };
}
